<script>
import Layout from '@layouts/main.vue'
import analyticsService from '@utils/analytics-service'
import { productMethods, authComputed } from '@state/helpers'
import ProductList from '@components/product-list.vue'
import ProductOfferCell from '@components/product-offer-cell.vue'

export default {
  page: {
    title: 'Product Search',
    meta: [{ name: 'description', content: 'The Product Search page.' }],
  },
  components: { Layout, ProductList, ProductOfferCell },
  data() {
    return {
      search: '',
      isWorking: false,
      noResults: false,
      searchResults: { products: [], listings: []},
      searchError: null,
    }
  },
  computed: {
    ...authComputed
  },
  mounted() {
    analyticsService.trackPageView('Product Search')
  },
  methods: {
    ...productMethods,
    trySearchForProducts() {
      this.isWorking = true
      this.noResults = false
      this.searchError = null
      this.searchResults = { products: [], listings: []}

      this.searchForProducts({ query: this.search, currentUser: this.currentUser })
        .then((res) => {
          if (res.message) {
            this.searchError = res.message
            return
          }

          if (res.productId) {
            this.$router.push({
              name: 'view-product',
              params: { productId: res.productId },
            })
            return
          }

          if (res.length === 1 && res[0] === 0) {
            this.noResults = true
            return
          }

          this.searchResults = res
        })
        .catch((err) => {
          this.searchError =
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'An unknown error occurred'
        })
        .finally(() => {
          this.isWorking = false
        })
    },
  },
}
</script>

<template>
  <Layout>
    <h3>Product/Listing Search</h3>

    <v-row>
      <v-col cols="9">
        <v-text-field
          v-model="search"
          placeholder="Enter a product name or URL to see if we're tracking it"
        />
      </v-col>
      <v-col>
        <BaseButton :disabled="isWorking" @click="trySearchForProducts">
          <span> Search <BaseIcon v-if="isWorking" name="sync" spin /> </span>
        </BaseButton>
      </v-col>
    </v-row>

    <div v-if="searchError">
      {{ searchError }}
    </div>

    <div>
      Results: ({{searchResults.products.length}}) products, ({{searchResults.listings.length}}) unattached listings
    </div>

    <div v-if="searchResults.products.length > 0">
      <h3>Products</h3>
      <ProductList :products="searchResults.products"></ProductList>
    </div>

    <div v-if="searchResults.listings.length > 0">
      <h3>Listings not attached to products</h3>
      <ProductOfferCell
          v-for="item in searchResults.listings"
          :key="item.uniqueId"
          :item="item"
          :display-name="true"
      >
      </ProductOfferCell>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
